import React from 'react';
import Text from '../text';
import { SIZES, APPEARANCES, TYPES } from './constants';
const Mark = ({
  children,
  size = SIZES.inherit,
  isHighlighted = false,
  appearance = APPEARANCES.inherit,
  // @ts-ignore TS(2322): Type 'null' is not assignable to type 'ValueOf<...>'.
  weight = null,
}) => (
  <Text
    type={TYPES.mark}
    size={size}
    appearance={appearance}
    weight={weight}
    isHighlighted={isHighlighted}
  >
    {children}
  </Text>
);

export default Mark;
